import {
  ApiFormWrapper,
  FormError,
  FormPasswordField,
  FormSubmitButton,
} from "@holigral/shared/form"
import { useChangePasswordMutation } from "@/auth"
import { useT } from "@/i18n"

export default function ChangePassword() {
  const { t } = useT("auth")
  const [changePassword] = useChangePasswordMutation()

  return (
    <ApiFormWrapper
      defaultValues={{
        password: "",
      }}
      action={changePassword}
      successMessage="Successfully changed password."
      resetOnSuccess
    >
      <FormPasswordField
        name="password"
        label="Password"
        isNewPassword
        className="mb-2 w-full"
      />
      <FormError />
      <FormSubmitButton>{t("changePassword")}</FormSubmitButton>
    </ApiFormWrapper>
  )
}
